// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FVhG","toggleWrap":"styles_toggleWrap__1evT1","content":"styles_content__2Chf7","selectAreaCode":"styles_selectAreaCode__1zw_U"};